import type { GridImportColumn, ImportRowError } from '../types'

const SKIP_TYPES = new Set(['checkbox', 'seq', 'image', 'file', 'files'])

function isEmptyValue(value: unknown) {
  return value == null || value === ''
}

export function validateImportRows(
  rows: Record<string, unknown>[],
  columns: GridImportColumn[],
  formatRequiredMessage: (title: string) => string = (title) => `${title}不能为空`,
  options?: { fieldsInFile?: string[] },
): ImportRowError[] {
  const fieldsInFile = options?.fieldsInFile
  const requiredColumns = columns.filter(
    (col) =>
      col.field &&
      col.required &&
      col.importable !== false &&
      !SKIP_TYPES.has(col.type ?? '') &&
      (!fieldsInFile?.length || fieldsInFile.includes(col.field)),
  )

  const errors: ImportRowError[] = []

  rows.forEach((row, rowIndex) => {
    for (const column of requiredColumns) {
      const value = row[column.field]
      if (isEmptyValue(value)) {
        const title = column.title || column.field
        errors.push({
          rowIndex: rowIndex + 1,
          field: column.field,
          title,
          message: formatRequiredMessage(title),
        })
      }
    }
  })

  return errors
}
